<cts-dynamic-form-hijri-dateitem
	name="date"
	[(ngModel)]="hijriDate"
	[selectedDateType]="customOptions?.dateType"
	[isDisabled]="disabled || viewOnly"
	[disabledbtn]="viewOnly"
	[minHijri]="minHijri"
	[maxHijri]="maxHijri"
	[minGreg]="minGreg"
	[maxGreg]="maxGreg"
	[isRequired]="required"
	(valueChanged)="onDateChanged($event)"
	[viewOnly]="viewOnly"
	[disableConverter]="customOptions?.disableConverter"
></cts-dynamic-form-hijri-dateitem>
